<template src="./CaseSolutionInput.html"></template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Case } from "@/models/cases/Case";
import { CodeLevelData } from "@/models/CodeLevelData";
import { CaseSolution } from "@/models/solution/CaseSolution";
import { codeLevelModule } from "@/store/modules/codeLevel";
import { CodeLevelActions } from "@/store/modules/codeLevel/actions";
import { CodeLevelGetters } from "@/store/modules/codeLevel/getters";
import CaseSolutionFields from "./CaseSolutionFields";

export default defineComponent({
    components: { CaseSolutionFields },
    props: {
        caseModel: { type: Object as PropType<Case>, required: true },
        solutions: { type: Array as PropType<CaseSolution[]>, required: true }
    },
    emits: ["update:solutions"],
    computed: {
        ...codeLevelModule.mapGetters({
            codeLevelsGetter: CodeLevelGetters.CodeLevelData,
            isLoading: CodeLevelGetters.IsLoading
        }),
        codeLevels() {
            return this.codeLevelsGetter as CodeLevelData | null;
        }
    },
    methods: {
        ...codeLevelModule.mapActions({
            loadCodeLevels: CodeLevelActions.LoadCodeLevels
        }),
        isPrimary(solution: CaseSolution): boolean {
            return (
                this.caseModel.codeLevelSets.find(
                    (cs) =>
                        cs.caseCodeLevelSetId === solution.caseCodeLevelSetId
                )?.isPrimary ?? false
            );
        },
        getSolutionName(solution: CaseSolution): string | null {
            if (!this.codeLevels) return null;

            const codeLevelSet = this.caseModel.codeLevelSets.find(
                (cs) => cs.caseCodeLevelSetId === solution.caseCodeLevelSetId
            );
            if (!codeLevelSet) return null;

            const area = this.codeLevels.codeLevelAreas.find(
                (a) => a.id === codeLevelSet.codeLevelAreaId
            );
            const topicGroup = area?.topicGroups.find(
                (t) => t.id === codeLevelSet.codeLevelTopicGroupId
            );
            const topicDetail = topicGroup?.codeLevelTopicDetails.find(
                (td) => td.id === codeLevelSet.codeLevelTopicDetailId
            );

            return `${area?.name} - ${topicGroup?.name} - ${topicDetail?.name}`;
        },
        updateSolution(index: number, solution: CaseSolution) {
            const updated = [...this.solutions];
            updated.splice(index, 1, solution);
            this.$emit("update:solutions", updated);
        }
    },
    async created() {
        await this.loadCodeLevels();
    }
});
</script>
